import React from 'react';

const SORT_OPTIONS = [
  { id: 'soldDate', label: 'Sold Date' },
  { id: 'scheduledDate', label: 'Install Date' },
  { id: 'customerName', label: 'Customer' },
  { id: 'status', label: 'Status' }
];

export default function JobsTableHeader({ sortBy, onSortChange }) {
  return (
    <div style={{
      padding: '12px 16px',
      background: 'var(--brand-brown-tint-soft)',
      borderRadius: '12px',
      border: '1px solid rgba(139, 69, 19, 0.2)',
      marginBottom: '16px'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <span style={{
          fontSize: '13px',
          fontWeight: '600',
          color: 'var(--text-primary)'
        }}>
          Sort by:
        </span>

        <div style={{
          display: 'flex',
          gap: '8px'
        }}>
          {SORT_OPTIONS.map(option => {
            const isSelected = sortBy === option.id;
            
            return (
              <button
                key={option.id}
                onClick={() => onSortChange(option.id)}
                style={{
                  padding: '6px 12px',
                  background: isSelected ? '#8B4513' : 'white',
                  border: `1px solid ${isSelected ? '#8B4513' : '#ddd'}`,
                  borderRadius: '8px',
                  fontSize: '12px',
                  fontWeight: '600',
                  color: isSelected ? 'white' : '#666',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  if (!isSelected) {
                    e.currentTarget.style.borderColor = '#8B4513';
                    e.currentTarget.style.background = 'rgba(139, 69, 19, 0.1)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isSelected) {
                    e.currentTarget.style.borderColor = '#ddd';
                    e.currentTarget.style.background = 'white';
                  }
                }}
              >
                {option.label}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}